export default __webpack_public_path__ + "static/media/background.ec3108c3.svg";